// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomPaperBox_wrapper__IcqVS","default":"CustomPaperBox_default__o0iQu","primary":"CustomPaperBox_primary__clEYZ","bold":"CustomPaperBox_bold__TwDO-"};